<template>
  <div class="page-content">
    <div class="mx-1">
    </div>
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-10 col-sm-10">
                <h4>Company Documents</h4>
              </div>
              <div class="col-2 col-sm-2">
                <button v-if="checkPermission.create" class="btn btn-primary btn-block" @click="showModalAdd = true; v$.documentForm.$touch();">Add Document</button>
              </div>
            </div>
            <div class="row d-flex justify-content-between align-items-center pt-3">
              <div class="col-12 col-sm-12">
                <form class="search-form" @submit.prevent="doSearch()">
                  <div class="input-group border rounded-sm">
                    <div class="input-group-prepend">
                      <div class="input-group-text border-0 rounded-sm">
                        <FeatherIcon type="search" class="icon-md cursor-pointer" />
                      </div>
                    </div>
                    <input v-model="search.search" type="text" class="form-control  border-0 rounded-sm" id="searchForm" placeholder="Search here...">
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Company Name</th>
                    <th>File Name</th>
                    <th>Category</th>
                    <th>Added Date</th>
                    <th>Upload By</th>
                    <th colspan="4">#</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in documentList" :key="item.id">
                    <td>{{ item.company.name }}</td>
                    <td>{{ item.file_name }}</td>
                    <td>{{ item.category }}</td>
                    <td>{{ item.created_at_str }}</td>
                    <td>{{ item.uploader ? item.uploader.full_name : '-' }}</td>
                    <td>
                      <a :href="item.full_url" target="_blank">
                        <button class="btn btn-outline-primary btn-sm mr-2">
                          <font-awesome icon="download"/>
                        </button>
                      </a>
                      <button v-if="checkPermission.update && (checkUser.role.name.toLowerCase() === 'admin' || (checkUser.role_id.toLowerCase() !== '2e673799-d373-4872-a3e1-05fbb3e419e4' && checkUser.id === item.created_by))" class="btn btn-outline-primary btn-sm mr-2" @click="showEditDocument(item)">
                        <font-awesome icon="user-edit"/>
                      </button>
                      <button v-if="checkPermission.delete && (checkUser.role.name.toLowerCase() === 'admin' || (checkUser.role_id.toLowerCase() !== '2e673799-d373-4872-a3e1-05fbb3e419e4' && checkUser.id === item.created_by))" class="btn btn-outline-primary btn-sm" @click="deleteDocument(item)">
                        <font-awesome icon="times"/>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <el-pagination
              :page-size="10"
              :current-page="parseInt(search.page)"
              layout="prev, pager, next"
              :total="this.dataTotal"
              @current-change="setPage"
              >
              </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="showModalAdd" title="Add New Document" hide-footer>
      <b-form ref="formAddDocument" @submit.prevent="createDocument" @reset="closeModal">
        <b-form-group id="companies" label="Companies:" label-for="company_id">
          <el-select @change="handlerChangeCompany" :placeholder="$t('companyDocuments.placeholder.company')" class="w-100" id="company_id"
            filterable
            :filter-method="handlerSearchCompany" v-model="documentForm.company_id">
            <el-option v-for="cp in company_list" :key="cp.id" :label="cp.name" :value="cp.id"></el-option>
          </el-select>
          <b-form-invalid-feedback :state="!v$.documentForm.company_id.$invalid" v-if="v$.documentForm.company_id.$errors[0]">
            {{ $t('validation.' + v$.documentForm.company_id.$errors[0].$validator) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="ig-file-name" label="File Name:" label-for="i-file-name">
          <b-form-input :placeholder="$t('companyDocuments.placeholder.file_name')" autocomplete="off" id="i-file-name" type="text" v-model="v$.documentForm.file_name.$model" />
          <b-form-invalid-feedback :state="!v$.documentForm.file_name.$invalid" v-if="v$.documentForm.file_name.$errors[0]">
            {{ $t('validation.' + v$.documentForm.file_name.$errors[0].$validator) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="ig-category-name" label="Category:" label-for="i-category-name">
          <el-select :placeholder="$t('companyDocuments.placeholder.category')" v-model="v$.documentForm.category.$model" class="w-100">
            <el-option v-for="(data, index) in documentTypeList" :key="index" :value="data.value" :label="data.label">{{ data.label }}</el-option>
          </el-select>
          <b-form-invalid-feedback :state="!v$.documentForm.category.$invalid" v-if="v$.documentForm.category.$errors[0]">
            {{ $t('validation.' + v$.documentForm.category.$errors[0].$validator) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="ig-file-name" label="Billed Amount:" label-for="i-file-name" v-if="documentForm.category.toLowerCase().includes('invoice')">
          <b-form-input :placeholder="$t('companyDocuments.placeholder.billed_amount')" autocomplete="off" id="i-billed-amount" type="text" v-model="v$.documentForm.billed_amount.$model" />
          <b-form-invalid-feedback :state="!v$.documentForm.billed_amount.$invalid" v-if="v$.documentForm.billed_amount.$errors[0]">
            {{ $t('validation.' + v$.documentForm.billed_amount.$errors[0].$validator) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="ig-workspaces" label="Applied Workspaces:" label-for="i-workspaces" v-loading="loading.workspace_list">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAllWorkspace" @change="handleCheckAllWorkspace">Check all</el-checkbox>
          <el-checkbox-group v-model="v$.documentForm.workspace_ids.$model" size="small">
            <span class="mr-2" v-for="data in workspaceList" :key="data._id">
              <el-checkbox border :label="data._id">{{ data.name }}</el-checkbox>
            </span>
          </el-checkbox-group>
          <b-form-invalid-feedback :state="!v$.documentForm.workspace_ids.$invalid" v-if="v$.documentForm.workspace_ids.$errors[0]">
            {{ $t('validation.' + v$.documentForm.workspace_ids.$errors[0].$validator) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          id="document-add-file_path"
          label="Attachment"
          label-for="document-add-file_path">
          <b-form-file
            ref="addDocumentFile"
            v-model="documentForm.file_path"
            placeholder="Choose a file or drop it here."
            drop-placeholder="Drop file here."
          ></b-form-file>
          <b-form-invalid-feedback :state="!v$.documentForm.file_path.$invalid" v-if="v$.documentForm.file_path.$errors[0]">
            {{ $t('validation.' + v$.documentForm.file_path.$errors[0].$validator) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <div class="d-flex flex-row-reverse">
          <!-- <b-button type="submit" variant="primary" class="ml-2">{{ $t('general.submit') }}</b-button> -->
          <el-button @click="createDocument" :loading="loading.add_document" class="btn ml-2 btn-primary">{{ $t('general.submit') }}</el-button>
          <b-button type="reset" variant="secondary">{{ $t('general.cancel') }}</b-button>
        </div>
      </b-form>
    </b-modal>
    <b-modal v-model="showModalEdit" title="Edit Document" hide-footer>
      <b-form ref="formAddDocument" @submit.prevent="createDocument" @reset="closeModal">
        <b-form-group id="companies" label="Companies:" label-for="company_id">
          <el-select class="w-100" id="company_id"
            filterable
            :filter-method="handlerSearchCompany" v-model="documentFormEdit.company_id">
            <el-option v-for="cp in company_list" :key="cp.id" :label="cp.name" :value="cp.id"></el-option>
          </el-select>
          <b-form-invalid-feedback :state="!v$.documentFormEdit.company_id.$invalid" v-if="v$.documentFormEdit.company_id.$errors[0]">
            {{ $t('validation.' + v$.documentFormEdit.company_id.$errors[0].$validator) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="ig-file-name" label="File Name:" label-for="i-file-name">
          <b-form-input id="i-file-name" type="text" v-model="documentFormEdit.file_name" />
          <b-form-invalid-feedback :state="!v$.documentFormEdit.file_name.$invalid" v-if="v$.documentFormEdit.file_name.$errors[0]">
            {{ $t('validation.' + v$.documentFormEdit.file_name.$errors[0].$validator) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="ig-category-name" label="Category:" label-for="i-category-name">
          <el-select v-model="documentFormEdit.category" class="w-100">
            <el-option v-for="(data, index) in documentTypeList" :key="index" :value="data.value" :label="data.label">{{ data.label }}</el-option>
          </el-select>
          <b-form-invalid-feedback :state="!v$.documentFormEdit.category.$invalid" v-if="v$.documentFormEdit.category.$errors[0]">
            {{ $t('validation.' + v$.documentFormEdit.category.$errors[0].$validator) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="ig-file-name" label="Billed Amount:" label-for="i-file-name" v-if="documentFormEdit.category.toLowerCase().includes('invoice')">
          <b-form-input :placeholder="$t('companyDocuments.placeholder.billed_amount')" autocomplete="off" id="i-billed-amount" type="text" v-model="v$.documentFormEdit.billed_amount.$model" />
          <b-form-invalid-feedback :state="!v$.documentFormEdit.billed_amount.$invalid" v-if="v$.documentFormEdit.billed_amount.$errors[0]">
            {{ $t('validation.' + v$.documentFormEdit.billed_amount.$errors[0].$validator) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="ig-workspaces" label="Applied Workspaces:" label-for="i-workspaces" v-loading="loading.workspace_list">
          <el-checkbox :indeterminate="isIndeterminateEdit" v-model="checkAllWorkspaceEdit" @change="handleCheckAllWorkspaceEdit">Check all</el-checkbox>
          <el-checkbox-group v-model="v$.documentFormEdit.workspace_ids.$model" size="small">
            <span class="mr-2" v-for="data in workspaceList" :key="data._id">
              <el-checkbox border :label="data._id">{{ data.name }}</el-checkbox>
            </span>
          </el-checkbox-group>
          <b-form-invalid-feedback :state="!v$.documentFormEdit.workspace_ids.$invalid" v-if="v$.documentFormEdit.workspace_ids.$errors[0]">
            {{ $t('validation.' + v$.documentFormEdit.workspace_ids.$errors[0].$validator) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="document-add-file_path" label="Attachment" label-for="document-add-file_path">
          <b-form-file ref="addDocumentFile" v-model="documentFormEdit.file_path"
            :accept="accepted_ext['document']"
            placeholder="Choose a file or drop it here." drop-placeholder="Drop file here."
          ></b-form-file>
          <div class="mt-3" v-if="documentFormEdit.full_url">
            Current attachment:<br>
            <a :href="documentFormEdit.full_url" target="_blank">View here</a>
          </div>
        </b-form-group>
        <div class="d-flex flex-row-reverse">
          <!-- <b-button type="submit" variant="primary" class="ml-2">{{ $t('general.submit') }}</b-button> -->
          <b-button variant="primary" size="sm" @click="updateDocument" :loading="loading.edit_document" class="ml-2">{{ $t('general.save') }}</b-button>
          <el-button size="small" type="info">{{ $t('general.cancel') }}</el-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>
<style>
#btn_link {
  background:none;border: none;color: #1e5b2a;
}
#btn_link:hover {
  text-decoration: underline;
  color: #143d1c;
}
.btn-search {
  margin-left: 1em;
}
.pageBox {
  background-color: #1e5b2a;
  color: white;
  padding: 0.5em 1em;
  margin: 0.5em 1em;
  cursor: pointer;
  border: 0;
}
.pageBox:hover {
  color: white;
}
</style>
<script>
import moment from 'moment';
import _ from 'lodash';
import mime from 'mime';
import useVuelidate from '@vuelidate/core';
import {
  required, requiredIf, numeric, minLength,
} from '@vuelidate/validators';

import documentAPI from '../../api/companyDocuments';
import workspaceAPI from '../../api/workspaces';
import popupErrorMessages from '../../library/popup-error-messages';
import base64File from '../../library/base64File';

export default {
  name: 'companyDocuments',
  metaInfo: {
    title: 'Company Documents',
  },
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  validations() {
    return {
      documentForm: {
        company_id: {
          required,
        },
        category: {
          required,
        },
        file_name: {
          required,
        },
        file_path: {
          required,
        },
        billed_amount: {
          required: requiredIf(this.documentForm.category.toLowerCase().includes('invoice')),
          numeric,
        },
        workspace_ids: {
          required,
          minLength: minLength(1),
        },
      },
      documentFormEdit: {
        company_id: {
          required,
        },
        file_name: {
          required,
        },
        category: {
          required,
        },
        billed_amount: {
          required: requiredIf(this.documentForm.category.toLowerCase().includes('invoice')),
          numeric,
        },
        workspace_ids: {
          required,
          minLength: minLength(1),
        },
      },
    };
  },
  data() {
    return {
      isIndeterminateEdit: false,
      isIndeterminate: false,
      checkAllWorkspaceEdit: false,
      checkAllWorkspace: false,
      loading: {
        add_document: false,
        documentlist: false,
        edit_document: false,
        workspace_list: false,
      },
      dataTotal: 0,
      dataSize: 0,
      page: 1,
      showModalAdd: false,
      showModalEdit: false,
      search: {
        search: this.$route.query.search || '',
        page: this.$route.query.page || 1,
        per_page: this.$route.query.per_page || 10,
      },
      documentList: [],
      documentCount: 0,
      loaderStack: 0,
      loader: null,
      documentForm: {
        company_id: '',
        file_name: '',
        category: '',
        file_path: null,
        billed_amount: '',
        workspace_ids: [],
      },
      documentFormEdit: {
        company_id: '',
        file_name: '',
        category: '',
        billed_amount: '',
        workspace_ids: [],
      },
      accepted_ext: {
        document: '.pdf, .xls, .xlsx, .docx, .doc, .csv, .ppt, .pptx, .txt',
      },
      company_list: [],
      last_index: null,
      get_company_id: '',
      documentTypeList: [
        {
          value: 'Quotation',
          label: 'Quotation',
        },
        {
          value: 'PKS',
          label: 'PKS',
        },
        {
          value: 'Usage Invoice',
          label: 'Usage Invoice',
        },
        {
          value: 'Subscription Invoice',
          label: 'Subscription Invoice',
        },
      ],
      workspaceList: [],
    };
  },
  computed: {
    // page() {
    //   if (this.$route.query.page) {
    //     return this.$route.query.page;
    //   }
    //   return 1;
    // },
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        console.log(val);
        this.page = val;
        this.loadList();
      },
    },
    checkUser() {
      return this.$store.state.backOffice.userProfile;
    },
    checkPermission() {
      const users = this.$store.state.backOffice.userProfile;
      const path = this.$router.currentRoute.fullPath;
      const permission = users.permissions.find((v) => path.includes(v.path));
      return permission.configuration;
    },
  },
  async mounted() {
    this.showLoader();
    await this.loadList();
    await this.getCompanies();
    this.hideLoader();
  },
  methods: {
    handleCheckAllWorkspaceEdit(val) {
      this.documentFormEdit.workspace_ids = val ? this.workspaceList.map((v) => v._id) : [];
      this.isIndeterminateEdit = !val;
    },
    handleCheckAllWorkspace(val) {
      this.documentForm.workspace_ids = val ? this.workspaceList.map((v) => v._id) : [];
      this.isIndeterminate = !val;
    },
    async loadWorkspaceByCompanyId(company_id) {
      this.loading.workspace_list = true;
      const response = await workspaceAPI.getList({
        company_id,
      });
      this.loading.workspace_list = false;
      if (!response.error) {
        this.workspaceList = response.data.rows;
        if (!this.documentFormEdit.workspace_ids.length) {
          this.documentFormEdit.workspace_ids = response.data.rows.map((v) => v._id);
          this.isIndeterminateEdit = true;
        }
      }
    },
    doSearch() {
      this.page = 1;
      this.search.page = 1;
      this.search.per_page = 10;
      this.loadList();
    },
    setPage(val) {
      this.search.page = val;
      this.page = val;
      this.loadList();
    },
    handlerSearchCompany(value) {
      clearTimeout(this.timeout_search_user);
      this.timeout_search_user = setTimeout(() => {
        this.getCompanies('company_name', value);
      }, 1000);
    },
    async loadList() {
      const options = {
        page: this.search.page.toString() || 1,
        per_page: this.search.per_page.toString() || 10,
        search: this.search.search,
      };

      if (!_.isMatch(this.$route.query, options)) {
        this.$router.replace({ query: options });
      }
      const loader = this.$loading.show();
      this.loading.documentlist = true;
      await documentAPI.getList(this.search.page, this.search.search, this.get_company_id)
        .then((res) => {
          this.dataTotal = res.data.count;
          this.dataSize = Math.ceil(this.dataTotal / 10);
          this.documentList = res.data.rows.map((document) => {
            const data = document;
            ['created_at'].forEach((v) => {
              data[`${v}_str`] = document[v] ? moment(document[v]).format('DD MMM YYYY, HH:mm') : '-';
            });
            return data;
          });
        }).catch((err) => {
          console.log(err);
          this.loading.documentlist = false;
          loader.hide();
        });
      this.loading.documentlist = false;
      loader.hide();
    },
    async createDocument() {
      this.v$.documentForm.$touch();
      if (this.v$.documentForm.$error) return;
      const {
        file_name,
        category,
        company_id,
        file_path,
      } = this.documentForm;
      this.documentForm.file = await base64File(file_path);
      // const fileExt = `.${mime.getExtension(file_path.type)}`;
      // const type = 'document';
      // const accepted = this.accepted_ext[type].split(',').map((v) => v.trim());
      // if (!accepted.includes(fileExt)) {
      //   this.$message({
      //     message: this.$t('general.error.file_not_supported'),
      //     type: 'warning',
      //     duration: 10 * 1000,
      //   });
      //   return;
      // }
      this.loading.add_document = true;
      const response = await documentAPI.createDocument({
        company_id,
        file_name,
        category,
        file: this.documentForm.file,
      }).catch(() => {});
      this.loading.add_document = false;
      await popupErrorMessages(response);
      this.$message({
        message: this.$t('companyDocuments.success.add'),
        type: 'success',
      });
      this.closeModal();
      this.loadList();
    },
    async getCompanies(search_by = '', search = '') {
      await documentAPI.getCompanies(1, search_by, search)
        .then(async (res) => {
          await popupErrorMessages(res);
          this.company_list = res.data.rows;
        });
    },
    moreText(string) {
      return string && string.length > 50 ? `${string.substr(0, 40)}...` : string;
    },
    showLoader() {
      if (this.loaderStack === 0) {
        this.loader = this.$loading.show();
      }
      this.loaderStack += 1;
    },
    hideLoader() {
      this.loaderStack -= 1;
      if (this.loaderStack === 0) {
        this.loader.hide();
      }
    },
    resetFormAdd() {
      this.documentForm = {
        category: '',
        file_name: '',
        file_path: null,
        company_id: '',
      };
    },
    closeModal() {
      this.showModalAdd = false;
      this.showModalEdit = false;
      this.resetFormAdd();
      this.resetFormEdit();
    },
    showEditDocument(obj) {
      this.showModalEdit = true;
      if (!obj.workspace_ids) {
        obj.workspace_ids = [];
      }
      this.documentFormEdit = _.cloneDeep(obj);
      this.v$.documentFormEdit.$touch();
      this.getCompanies('company_name', obj.company.name);
      this.loadWorkspaceByCompanyId(obj.company_id);
    },
    handlerChangeCompany(val) {
      this.loadWorkspaceByCompanyId(val);
    },
    async updateDocument() {
      this.v$.documentFormEdit.$touch();
      if (this.v$.documentFormEdit.$error) return;
      if (this.documentFormEdit.file_path) {
        this.documentFormEdit.file = await base64File(this.documentFormEdit.file_path);
        const fileExt = `.${mime.getExtension(this.documentFormEdit.file_path.type)}`;
        const type = 'document';
        const accepted = this.accepted_ext[type].split(',').map((v) => v.trim());
        if (!accepted.includes(fileExt)) {
          this.$message({
            message: this.$t('general.error.file_not_supported'),
            type: 'warning',
            duration: 10 * 1000,
          });
          return;
        }
      } else {
        this.documentFormEdit.file = null;
      }
      this.loading.edit_document = true;
      const response = await documentAPI.updateDocument(this.documentFormEdit).catch(() => {});
      this.loading.edit_document = false;
      await popupErrorMessages(response);
      this.$message({
        message: this.$t('companyDocuments.success.edit'),
        type: 'success',
      });
      this.page = 1;
      this.search = {
        search: this.$route.query.search || '',
        page: this.$route.query.page || 1,
        per_page: this.$route.query.per_page || 10,
      };
      this.loadList();
      this.closeModal();
    },
    deleteDocument(document) {
      this.$confirm(this.$t('companyDocuments.confirm.delete'), this.$t('general.confirmation'), {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
        beforeClose: async (action, instance, cb) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            await documentAPI.deleteDocument(document.company_id, document.id)
              .then(async (response) => {
                await popupErrorMessages(response);
                this.$message({
                  message: this.$t('companyDocuments.success.delete'),
                  type: 'success',
                });
                this.page = 1;
                this.search = {
                  search: this.$route.query.search || '',
                  page: this.$route.query.page || 1,
                  per_page: this.$route.query.per_page || 10,
                };
                this.loadList();
              });
          }
          instance.confirmButtonLoading = false;
          cb();
        },
      }).catch(() => {});
    },
    resetFormEdit() {
      this.documentFormEdit = {
        category: '',
        file_name: '',
        file_path: null,
        company_id: '',
      };
    },
  },
};
</script>
